<template>
	<div>
		<ts-loading-banner :loading="loading">
				<div class="ts-border ts-p-3 ts-rounded ts-overflow-y-scroll max-h">
					<table class="ts-w-full ts-mt-2">
						<thead>
							<tr>
								<th class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2"
								>
									{{ $t('sparePartReplacement.barcode') }}
								</th>
								<th class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2"
								>
									{{ $t('sparePartReplacement.productName') }}
								</th>
								<th class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2"
								>
									{{ $t('sparePartReplacement.uom') }}
								</th>
								<th
									class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2"
								>
									{{ $t('sparePartReplacement.quantity') }}
								</th>
								<th
									class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2"
								>
									{{ $t('sparePartReplacement.remark') }}
								</th>
								<th
									class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2"
								>
									{{ $t('sparePartReplacement.technician') }}
								</th>
								<th
									class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-w-12 ts-text-center"
								>
									<a href="#"
										@click.prevent="addNew"
									>
										<i class="fa fa-plus"></i>
									</a>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(item, index) in model.product_list"
								:key="index"
							>
								<td valign="top" class="ts-p-2 ts-w-56">
									<a-select
										ref="barcode"
										v-model="item.product_id"
										class="ts-w-full"
										:class="{'is-invalid': errors.has('product_list.' + index + '.product_id')}"
										:filterOption="(input, option) =>option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
										showSearch
										@change="onProductChange(item)"
									>
										<a-select-option
											v-for="(pro, index) in getProduct({
												chosenProduct: model.product_list,
												productCurrentRow: item.product_id,
											})"
											:key="index"
											:value="pro.product_id"
											>{{ pro.barcode }}</a-select-option
										>
									</a-select>
									<div class="invalid-feedback" v-if="errors.has('product_list.' + index + '.product_id')">
										{{ errors.first('product_list.' + index + '.product_id') }}
									</div>
								</td>
								<td  valign="top" class="ts-p-2">
									<a-select
										ref="product"
										v-model="item.product_id"
										class="ts-w-full"
										:class="{'is-invalid': errors.has('product_list.' + index + '.product_id')}"
										:filterOption="(input, option) =>option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
										showSearch
										@change="onProductChange(item)"
									>
										<a-select-option
											v-for="(pro, index) in getProduct({
												chosenProduct: model.product_list,
												productCurrentRow: item.product_id,
											})"
											:key="index"
											:value="pro.product_id"
											>{{ pro.product_name_en }}</a-select-option
										>
									</a-select>
									<div class="invalid-feedback" v-if="errors.has('product_list.' + index + '.product_id')">
										{{ errors.first('product_list.' + index + '.product_id') }}
									</div>									
								</td>
								<td  valign="top" class="ts-p-2">
									<a-select
										v-model="item.uom_id" 
										class="ts-w-full"
										:class="{ 'is-invalid': errors.has('product_list.' + index + '.uom_id')}"
									>
										<a-select-option
											v-for="(u, index) in getUom(item.product_id)"
											:key="index"
											:value="u.uom_id"
										>{{ u.uom_name_en }} </a-select-option>
									</a-select>
									<div class="invalid-feedback" v-if="errors.has('product_list.' + index + '.uom_id')">
										{{ errors.first('product_list.' + index + '.uom_id') }}
									</div>
								</td>
								<td valign="top" class="ts-p-2 ts-w-32">
									<input
										v-model.number="item.quantity" 
										type="number"
										ref="qty"
										@keypress.enter="onQtyEnter(index)"
										class="form-control"
										:class="{ 'is-invalid': errors.has('product_list.' + index + '.quantity')}"  
									/>
									<div class="invalid-feedback" v-if="errors.has('product_list.' + index + '.quantity')">
										{{ errors.first('product_list.' + index + '.quantity') }}
									</div>
								</td>
								<td valign="top" class="ts-p-2">
									<input
										ref="remark" 
										v-model.trim="item.remark"
										@keypress.enter="onRemarkEnter(index)"
										type="text" class="form-control">
								</td>
								<td class="ts-w-48">
									<a-select 
										show-search
										v-model.number="item.technician_id"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :not-found-content="null"
                    @search="(value) => handleSearchEmployee(value, item)"
                    class="ts-w-full"
                  >
                    <a-select-option 
                      v-for="emp in employeeList" :key="emp.employee_id"
                      :disabled="true"
                    >
                      {{ emp.employee_name_en }}
                    </a-select-option>
                  </a-select>
									<div class="validate" v-if="errors.has('product_list.' + index + '.technician_id')">
										{{ errors.first('product_list.' + index + '.technician_id') }}
									</div>
								</td>
								<td class="ts-text-center ts-p-2" valign="middle">
									<a href="#" class="text-red ts-my-auto"
										@click.prevent="removeRow(index)"
									>
										<i class="fa fa-trash"></i>
									</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
		</ts-loading-banner>
	</div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
	name: 'itemDetail',
	props: ['value', 'validate'],
  data() {
    return {
			loading: false,
			errors: new Errors(),
			model: {},
			row: {
				product_id: null,
				uom_id: null,
				quantity: 1,
				remark: null,
				technician_id: null
			},
			employeeList: []
		}
  },
	computed: {
    ...mapState('wholesale/replacement', ['edit_data', 'products']),
    ...mapGetters('wholesale/replacement', ['getUom', 'isDefaultUom', 'getProduct']),
    isEdit(){
      return !_.isEmpty(this.edit_data)
    }
	},
	async created(){
		this.loading = true
		this.model = this.value
		if(this.$route.params.id){
			await this.find(this.$route.params.id)
			await this.setEditData()
		}
		if(!this.isEdit){
			this.addNew()
    }
		await this.fetchEmployee()
		this.loading = false
	},
	methods: {
		...mapActions('wholesale/replacement', ['find', 'getMainProduct', 'getReplacementProduct', 'getEmployee']),
		addNew() {
			this.model.product_list.push(_.clone(this.row))
		},
		removeRow(index){
			this.model.product_list.splice(index, 1)
		},
		onProductChange(row){
      row.uom_id = this.isDefaultUom(row.product_id)
    },
		onQtyEnter(index){
			this.$refs.remark[index].focus()
		},
		onRemarkEnter(index){
			if(this.model.product_list.length == index + 1){
        this.addNew()
      }
			this.$nextTick(() => {
				this.$refs.barcode[index + 1].focus()
			})
		},
		async setEditData(){
			if(this.isEdit){
				this.model.replacement_date = this.edit_data.replacement_date
				this.model.remarks = this.edit_data.remarks
				this.model.product_id = this.edit_data.product_id
				this.model.uom_id = this.edit_data.uom_id
				this.model.serial_no = this.edit_data.serial_no
				this.model.product_grade =this.edit_data.new_product_grade
				this.$parent.fetchOptions.search_value = this.edit_data.serial_no
				this.model.product_list = this.edit_data.replacement_details.map(el => ({
						product_id: el.product_id,
						uom_id: el.uom_id,
						quantity: el.quantity,
						remark: el.remarks,
						technician_id: el.technician_id
				}))
				this.loading = true
				let response = await this.getMainProduct({ search_value: this.model.serial_no })
						this.$parent.main_products = response.data
						if(response.data[0].product_add_on.length == 0){
								await this.getReplacementProduct()
						}else {
								let products = response.data[0].product_add_on.map((el) => el.sale_code.product)
								this.$store.commit('wholesale/replacement/SET_PRODUCT', products)
						}
				this.loading = false
				return Promise.resolve()
			}
		},
		fetchEmployee(){
			this.loading = true
			this.getEmployee()
				.then(response => {
						this.employeeList = response.data
				})
				.finally(() => {
					this.loading = false
				})
		},    
		handleSearchEmployee(value, item){
			let em = this.employeeList.find(em => em.card_id == value)
			if(em){
				item.technician_id = em.employee_id
			}
		}
	},
	watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.max-h {
	min-height: 30vh;
  max-height: 70vh;
}
table {
  position: relative;
  border-collapse: collapse;
}
th {
	z-index: 1000;
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
  /* box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); */
}
</style>